import React, {useState} from "react"
import useAsyncResultIdle from "../../../hooks/useAsyncResultIdle"
import {Account} from "../../../resources/account"
import {useAccessToken} from "../../../services/auth"
import {Address} from "../../../resources/common"
import {createClosureCheckPayment} from "../../../resources/checkPayments"
import Admonition from "../../../components/Admonitions/Admonition"
import {Modal} from "../../../components/Modals/Modal"
import Button from "../../../components/Button/Button"
import CheckMailingAddress from "./CheckMailingAddress"
import {handleSubmit, refreshAndClose} from "./Utils"

interface NewClosureCheckModalProps {
	account: Account
	customerId: string
	updatedAddress: Address
	openChangeAddressModal: () => void
	closeModal: () => void
	onSuccess: () => void
}

export function NewClosureCheckModal({
	account,
	customerId,
	updatedAddress,
	openChangeAddressModal,
	closeModal,
	onSuccess,
}: NewClosureCheckModalProps) {
	const accessToken = useAccessToken()
	const accountId = account.id
	const [, create] = useAsyncResultIdle(createClosureCheckPayment)

	const [isLoading, setLoading] = useState(false)
	const [successMessage, setSuccessMessage] = React.useState("")
	const [errorMessage, setErrorMessage] = React.useState("")

	const onSubmit = () => {
		handleSubmit({
			createFn: create,
			params: {accessToken, accountId, customerId, addressOverride: updatedAddress},
			setLoading,
			setSuccessMessage,
			setErrorMessage,
			onSuccess,
			closeModal,
			successMessage: "Check issued successfully",
		})
	}

	return (
		<Modal
			classname="closure-check-modal"
			close={() => refreshAndClose(onSuccess, closeModal)}
			enableClickAway={true}
			blockBodyScroll={true}
		>
			<div className="modal-content">
				<h3 className="title is-4">You Are About to Issue Closure Check for account #{accountId}</h3>

				<Admonition
					type={"is-warning"}
					message={
						<p>
							A check for the remaining amount of ${account.attributes.balance / 100} will be sent. This action cannot
							be undone.
						</p>
					}
					title={"Please Note"}
				/>

				<CheckMailingAddress address={updatedAddress} openChangeAddressModal={openChangeAddressModal} />

				<div className="modal-actions is-flex is-justify-content-end padding">
					<Button className="button is-light transparent" theme={"neutral"} onClick={closeModal}>
						Cancel
					</Button>
					<Button className="button is-black wider" loading={isLoading} onClick={onSubmit}>
						Issue Check
					</Button>
				</div>
				<div className="modal-actions is-flex is-justify-content-end">
					{successMessage && <p className={"success-message"}>{successMessage}</p>}
					{errorMessage && <p className={"error-message"}>{errorMessage}</p>}
				</div>
			</div>
		</Modal>
	)
}
